import { useState } from "react";
import { toast } from "sonner";
import { verifyPasscode } from "@/lib/api";
import { Lock, Waves } from "lucide-react";

export const PasscodeGate = ({ onUnlock }) => {
  const [passcode, setPasscode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await verifyPasscode(passcode);
      sessionStorage.setItem("orsers_admin", "1");
      onUnlock();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Incorrect passcode");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative z-[2] flex min-h-screen items-center justify-center bg-retro-blue px-6" data-testid="passcode-gate">
      <form onSubmit={handleSubmit} className="w-full max-w-sm border-2 border-retro-ink bg-white p-8 shadow-retro-xl">
        <div className="mb-6 inline-flex items-center gap-2 border-2 border-retro-ink bg-retro-yellow px-4 py-2 shadow-retro-sm">
          <Lock className="h-5 w-5 text-retro-ink" />
          <span className="font-chango text-sm text-retro-ink">Host access</span>
        </div>
        <h1 className="font-chango text-3xl text-retro-ink">Enter the passcode</h1>
        <p className="mt-2 mb-6 font-medium text-retro-ink/70">Only the Orsers get past this point.</p>
        <input
          type="password"
          data-testid="passcode-input"
          className="w-full border-2 border-retro-ink bg-white px-4 py-3 text-lg font-medium outline-none focus:border-retro-orange"
          placeholder="Passcode"
          value={passcode}
          onChange={(e) => setPasscode(e.target.value)}
          autoFocus
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="passcode-submit-button"
          className="mt-6 flex w-full items-center justify-center gap-2 rounded-full border-2 border-retro-ink bg-retro-orange px-6 py-3 font-chango text-lg text-white shadow-retro transition-[transform,box-shadow] duration-150 hover:translate-x-[2px] hover:translate-y-[2px] hover:bg-retro-orangeDark hover:shadow-retro-sm disabled:opacity-70"
        >
          <Waves className="h-5 w-5" />
          Unlock
        </button>
      </form>
    </div>
  );
};
